export function mergeCompleteRouteSegments(segments) {
  const merged = [];
  (Array.isArray(segments) ? segments : []).forEach((segment) => {
    const points = (Array.isArray(segment) ? segment : []).filter(
      (point) =>
        point &&
        Number.isFinite(Number(point.lat)) &&
        Number.isFinite(Number(point.lon ?? point.lng))
    );
    if (!points.length) return;
    if (!merged.length) {
      merged.push(...points);
      return;
    }
    const last = merged[merged.length - 1];
    const first = points[0];
    if (
      Number(last.lat) === Number(first.lat) &&
      Number(last.lon ?? last.lng) === Number(first.lon ?? first.lng)
    ) {
      merged.push(...points.slice(1));
    } else {
      merged.push(...points);
    }
  });
  return merged;
}
